const faqNodes = document.querySelectorAll('.wdgt-faq');

faqNodes.forEach((faqNode) => {
    window.fireOnVisible(faqNode, async() => {
        await import('./assets/css/wdgt-faq.scss');

        let showMoreBtnHandler = (showMoreBtn) => {
            if (showMoreBtn.type === 'click') {
                showMoreBtn = showMoreBtn.target;
            }

            let attributes = {
                more: {
                    txt: showMoreBtn.dataset.btnTextOn || 'show more',
                    class: 'show_more'
                },
                less: {
                    txt: showMoreBtn.dataset.btnTextOff || 'show less',
                    class: 'show_less'
                }
            };

            let currentText = showMoreBtn.innerText || attributes.more.txt;

            showMoreBtn.innerText = currentText === attributes.less.txt ? attributes.more.txt : attributes.less.txt;

            if (showMoreBtn.classList.contains(attributes.more.class)) {
                showMoreBtn.classList.remove(attributes.more.class);
                showMoreBtn.classList.add(attributes.less.class);
            } else {
                showMoreBtn.classList.remove(attributes.less.class);
                showMoreBtn.classList.add(attributes.more.class);
            }
        };

        let showMoreBtn = faqNode.querySelector('.showMoreBtn');

        if (showMoreBtn) {
            showMoreBtnHandler(showMoreBtn);
            showMoreBtn.addEventListener('click', showMoreBtnHandler, false);
        }
    });
});
